import DOMPurify from 'isomorphic-dompurify';

const AboutPage = (props: any) => {
  const { facilityData } = props;
  const aboutTitle = facilityData?.attributes?.About_Title;
  const description = facilityData?.attributes?.About_Facility;
  return (
    <div>
      <section className="sv-about-access-storage">
        <div className="container">
          {aboutTitle && <h1 className="section-heading">{aboutTitle}</h1>}
          <div className="row">
            {description && (
              <div className="col-lg-8">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(description),
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
